export default __webpack_public_path__ + "static/media/doc_rock.24b3a5ed.png";